import { join, concat } from "lodash";

export const multipleClassesName = (classNames) =>
  join(concat(classNames), " ");

export const generateUUID = () => crypto.randomUUID();

export const capitaliseFirst = (str) => {
  if (!str) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitaliseWords = (str) => {
  if (!str) {
    return "";
  }
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};
